import Mutations from '../../odata/mutations';

export default { ...new Mutations('delivery'), ...new Mutations('deliveries') };
